<template>
  <div>
    <base-header class="pb-6">
      <b-row class="align-items-center py-4">
        <b-col lg="6" cols="7">
          <h6 class="h2 text-white d-inline-block mb-0">Variable Expense</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-breadcrumb/>
          </nav>
        </b-col>
        <!--
        <b-col lg="6" cols="5" class="text-right">
          <base-button size="sm" type="neutral">New</base-button>
          <base-button size="sm" type="neutral">Filters</base-button>
        </b-col>
        -->
      </b-row>
    </base-header>

    <b-container fluid class="mt--6">
      <b-row>
        <b-col lg="12">
          <div class="card-wrapper">
            <!-- Input groups -->
            <card>
              <!-- Card header -->
              <h3 slot="header" class="mb-0">Edit Variable Expense</h3>
              <!-- Card body -->
              <form>
                <!-- Input groups with icon -->
                <b-row>
                  <b-col md="4">
                    <base-input label="Variable Expense Title" placeholder="Title" v-model="variable_expense.variable_expense_title"></base-input>
                  </b-col>
                  <b-col md="4">
                    <base-input label="Variable Expense Value" placeholder="Value" v-model="variable_expense.variable_expense_value"></base-input>
                  </b-col>
                </b-row>
                <br>
                <base-button type="primary" @click="updateData()">Create / Save</base-button>
                <base-button type="primary" @click="$router.back()">Cancel</base-button>
              </form>
            </card>
          </div>
        </b-col>
      </b-row>
    </b-container>

  </div>
</template>

<script>
import axios from 'axios'
import {LoginURL, clientId, clientSecret, apiDomain, getHeader} from '@/assets/js/config.js'
import clientPaginationMixin from '@/assets/js/clientPaginationMixin'

  export default {
    mixins: [clientPaginationMixin],
    data() {
      return {
        variable_expense: {
          variable_expense_title: null,
          variable_expense_value: null,
        },
      }
    },
    created() {
      this.setSelectOption();
    },
    methods: {
      updateData(){
        const postData = {
          variable_expense_title : this.variable_expense.variable_expense_title,
          variable_expense_value : this.variable_expense.variable_expense_value,
        }

        axios.put(apiDomain + 'setup/variable_expense/' + this.$route.params.id , postData ,{ headers: getHeader() })
        .then ( response => {
          if (response.status === 200)
          {
            this.$notify({
              message:
                '<b>Variable Expense : ' + response.data.data[0].variable_expense_title + '</b> - Successfully Updated.',
              timeout: 10000,
              icon: 'ni ni-bell-55',
              type: 'default',
            });
            this.$router.back()


          }
        })
        .catch ( error => {
             
            _gNotif.errorFunction(error,null, "Update Variable Expense")
            
        });
      },
      setSelectOption() {
        axios.get(apiDomain + 'setup/variable_expense/' + this.$route.params.id ,{ headers: getHeader() })
        .then ( response => {
          if (response.status === 200)
          {
            this.variable_expense.variable_expense_title  = response.data.data[0].variable_expense_title
            this.variable_expense.variable_expense_value  = response.data.data[0].variable_expense_value
          }
        })
        .catch ( error => {
             
            _gNotif.errorFunction(error,null, "Show Variable Expense")
            
        });
      },
    }
  }
</script>